import { render, staticRenderFns } from "./objectsView.vue?vue&type=template&id=73f23678&"
import script from "./objectsView.vue?vue&type=script&lang=js&"
export * from "./objectsView.vue?vue&type=script&lang=js&"
import style0 from "./objectsView.vue?vue&type=style&index=0&id=73f23678&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports